import type { FileMetaDto } from "../api";
import { DocumentsTypes } from "../types";

export type FileSystemTab = "models" | "docs" | "drawings";

const DOCS_FILE_TYPES = new Set<string>([DocumentsTypes.file, DocumentsTypes.pdf_document]);

const MODEL_FILE_TYPES = new Set<string>([DocumentsTypes.model, DocumentsTypes.cosmos, DocumentsTypes.cosmos_geoserver]);

export function inferUploadDocumentType(fileName: string): {
  type: typeof DocumentsTypes.model | typeof DocumentsTypes.pdf_document;
  ext: string;
} {
  const ext = fileName.split(".").pop()?.toLowerCase() || "";
  if (ext === "pdf") {
    return { type: DocumentsTypes.pdf_document, ext };
  }

  return { type: DocumentsTypes.model, ext: ext || "ifc" };
}

export function fileMatchesTab(file: FileMetaDto, tab: FileSystemTab): boolean {
  if (tab === "docs") {
    return DOCS_FILE_TYPES.has(file.type);
  }

  if (tab === "models") {
    return MODEL_FILE_TYPES.has(file.type);
  }

  return false;
}

export function fileOrFolderMatchesTab(item: FileMetaDto, tab: FileSystemTab): boolean {
  if (item.type === DocumentsTypes.folder) {
    return true;
  }

  return fileMatchesTab(item, tab);
}
